module.exports = __webpack_public_path__ + "static/media/working.cb08babf.svg";